var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1bc092",
  fillRule: "evenodd",
  d: "M5.69 12L16 1.679 14.378 0 5.691 8.725 1.622 4.624 0 6.248z"
})));
export default __webpack_public_path__ + "static/media/check.e7119449.svg";
export { SvgComponent as ReactComponent };